const __vite_glob_0_5 = "/* document sidebar */\n.light-mode .t-doc__sidebar,\n.dark-mode .t-doc__sidebar {\n  z-index: 2;\n}\n/* document layout */\n.dark-mode .t-doc .layout-content {\n  background: transparent;\n}\n";
export {
  __vite_glob_0_5 as default
};
//# sourceMappingURL=mars.css.js.map
